module.exports = __webpack_public_path__ + "img/蒙牛.db383277.png";